<template>
    <b-list-group-item
        class="lista-menu"
        @click.stop="abrirModal()"
        ><span>RELATÓRIO DE FATURAMENTO DOS SERVIÇOS</span>
        <filtro
            ref="filtroModal"
            :servicos="obterFaturamentoServicos()"
            @filtrar="obterRelatorio($event)"
        ></filtro>
    </b-list-group-item>
</template>

<script>
import download from '../../../shared/download'
import filtro from './RelatorioFaturamentoServicosFiltro'
import RelatorioFaturamentoServicosServicos from './RelatorioFaturamentoServicosServicos'

export default {
    components: {
        filtro
    },

    methods: {
        abrirModal() {
            this.$refs.filtroModal.abrir()
        },

        obterRelatorio(filtro) {
            this.$store.dispatch('addRequest')
            RelatorioFaturamentoServicosServicos.obterRelatorioFaturamentoServicos(filtro).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Falha ao obter relatório',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        download(response, `Relatorio_Faturamento_Servicos.xlsx`)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterFaturamentoServicos() {
            return RelatorioFaturamentoServicosServicos
        }
    }
}
</script>